var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0C2.46734 0 0 2.46721 0 5.5C0 8.53279 2.46734 11 5.5 11C8.53266 11 11 8.53279 11 5.5C11 2.46721 8.53266 0 5.5 0ZM5.5 10.382C2.80809 10.382 0.617977 8.19191 0.617977 5.5C0.617977 2.80809 2.80809 0.617977 5.5 0.617977C8.19191 0.617977 10.382 2.80809 10.382 5.5C10.382 8.19191 8.19191 10.382 5.5 10.382ZM5.80899 5.36849V1.64802C5.80899 1.47734 5.67069 1.33903 5.5 1.33903C5.32931 1.33903 5.19101 1.47734 5.19101 1.64802V5.5C5.19101 5.58404 5.22525 5.66451 5.28593 5.72272L7.4077 7.76217C7.46752 7.81976 7.54464 7.84844 7.62176 7.84844C7.70284 7.84844 7.78392 7.81667 7.84461 7.75352C7.96276 7.63042 7.95893 7.43489 7.83596 7.31661L5.80899 5.36849Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.b2a84d34d75a158f0c0d939a18e54d9a.svg";
export { ForwardRef as ReactComponent };